import { translate } from '@utils/i18n';
import { visibilitySummary, formatFileSize } from './attachmentFormatting';
const NS = 'features.building_attachments.upload';
const VISIBILITY_NS = 'features.building_attachments.edit_modal.visibility';
const TECHS_VALUE = 'techs';
const PORTAL_VALUE = 'portal';
/** All `AddAttachmentsBrushaway` copy -- this organism takes `labels` and never imports
 *  `translate` itself (`@ui` stays copy-free, per task-09's scope boundary). */
export function buildAddAttachmentsLabels(maxSizeBytes) {
    const sizeLimitLabel = formatFileSize(maxSizeBytes);
    return {
        title: translate('title', { namespace: NS }),
        columnName: translate('column_name', { namespace: NS }),
        columnCategory: translate('column_category', { namespace: NS }),
        columnVisibleTo: translate('column_visible_to', { namespace: NS }),
        columnType: translate('column_type', { namespace: NS }),
        retryActionLabel: translate('retry_action', { namespace: NS }),
        removeActionLabel: (fileName) => translate('remove_action', { namespace: NS, fileName }),
        metaSize: (size) => translate('meta.size', { namespace: NS, size }),
        metaWaiting: (size) => translate('meta.waiting', { namespace: NS, size }),
        metaUploaded: (size) => translate('meta.uploaded', { namespace: NS, size }),
        metaFinalizing: (size) => translate('meta.finalizing', { namespace: NS, size }),
        footerTotals: (count, size) => translate('footer_totals', { namespace: NS, count, size }),
        cancelActionLabel: translate('cancel_action', { namespace: NS }),
        metaFailed: (size) => translate('meta.failed', { namespace: NS, size }),
        addButtonLabel: (count) => translate('add_button', { namespace: NS, count }),
        uploadingSummary: (done, total, pct) => translate('uploading_summary', { namespace: NS, done, total, pct }),
        uploadedSummary: (done, total, failed) => translate('uploaded_summary', { namespace: NS, done, total, failed }),
        cancelUploadLabel: translate('cancel_upload', { namespace: NS }),
        retryFailedLabel: translate('retry_failed', { namespace: NS }),
        rejectedAlertTitle: (count) => translate('rejected_alert.title', { namespace: NS, count }),
        rejectedAlertMessage: (fileName, size) => translate('rejected_alert.message', { namespace: NS, fileName, size, limit: sizeLimitLabel }),
        dropzoneNote: translate('dropzone_note', { namespace: NS, limit: sizeLimitLabel }),
        removeConfirmTitle: translate('remove_confirm.title', { namespace: NS }),
        removeConfirmDescription: (fileName) => translate('remove_confirm.description', { namespace: NS, fileName }),
        removeConfirmConfirmLabel: translate('remove_confirm.confirm_label', { namespace: NS }),
        removeConfirmCancelLabel: translate('remove_confirm.cancel_label', { namespace: NS }),
        discardConfirmTitle: translate('discard_confirm.title', { namespace: NS }),
        discardConfirmDescription: translate('discard_confirm.description', { namespace: NS }),
        discardConfirmConfirmLabel: translate('discard_confirm.confirm_label', { namespace: NS }),
        discardConfirmCancelLabel: translate('discard_confirm.cancel_label', { namespace: NS }),
        closeLabel: translate('close_label', { namespace: NS })
    };
}
/**
 * The organism's generic per-column config, built from this feature's own category/visibility
 * domain data -- keeps `@ui` free of attachment-domain option lists (task-09's storage-agnostic
 * requirement). Reuses the edit modal's existing `techs_label`/`portal_label` keys and
 * `visibilitySummary` rather than duplicating them under `upload.*`.
 */
export function buildAddAttachmentsColumns(categoryOptions, showPortalVisibilityOption, onCategoryChange, onVisibilityChange, addCategory) {
    return {
        category: {
            options: categoryOptions.map((option) => ({ value: option.id, label: option.label })),
            onChange: onCategoryChange,
            addCategoryLabel: addCategory === null || addCategory === void 0 ? void 0 : addCategory.label,
            onRequestAddCategory: addCategory === null || addCategory === void 0 ? void 0 : addCategory.onRequest
        },
        visibility: {
            options: [
                { value: TECHS_VALUE, label: translate('techs_label', { namespace: VISIBILITY_NS }) },
                ...(showPortalVisibilityOption
                    ? [{ value: PORTAL_VALUE, label: translate('portal_label', { namespace: VISIBILITY_NS }) }]
                    : [])
            ],
            getSummary: (values) => visibilitySummary(!values.includes(TECHS_VALUE), values.includes(PORTAL_VALUE), (key) => translate(key, { namespace: 'features.building_attachments.table' })),
            onChange: onVisibilityChange
        }
    };
}
